// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Lottie.Common {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: calc(100vh - var(--header-height));
  top: 0;
  left: 0;
  z-index: 99;
}
.Lottie.Common > div {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.Lottie.Common > div + * {
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/common/Lottie/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAEJ;AADI;EACE,UAAA;AAGN","sourcesContent":[".Lottie.Common {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: calc(100vh - var(--header-height));\n  top: 0;\n  left: 0;\n  z-index: 99;\n  > div {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    + * {\n      z-index: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
